import React from 'react';

import {LinkButton} from "../../misc/buttons/link-button";
import {Image} from "../../image/image";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {AllScoresLinkModel} from "../../../../containers/all-scores-container/models/all-scores-container-link-model";
import {SPORT_TYPES} from "../../../app/consts";

export class ScoresDesktopLiveEmptyStateProps extends BaseProps {
  text: String;
  buttonText: String;
  linkModel: AllScoresLinkModel;
  ImageSrc: String;
  onClick: Function;
}

export const ScoresDesktopLiveEmptyState = ({text, buttonText, linkModel, ImageSrc, onClick}: ScoresDesktopLiveEmptyStateProps) => {
  const imageProps = {
    src: new ImageSrc(107, 54, SPORT_TYPES.onTv),
    className: 'scores-list-widget-desktop-live-empty-state-image'
  }

  return (
    <div className={'scores-list-widget-desktop-live-empty-state'}>
      <Image {...imageProps}/>
      <div className={'scores-list-widget-desktop-live-empty-state-text'}>
        {text}
      </div>
      <LinkButton linkModel={linkModel} className={'scores-list-widget-desktop-live-empty-state-button'}
                  label={buttonText} enabled={true} onClick={onClick}/>
    </div>
  )
}
